export default "__VITE_ASSET__3c596d58__"